/* eslint-disable @typescript-eslint/no-unused-vars */

import { getAllLanguages } from '../../../../../../../../crud/configuration_api/languages';
import { getAllTimezones } from '../../../../../../../../crud/configuration_api/timezones';
import { getAllMonedas } from '../../../../../../../../crud/configuration_api/monedas';
import { getAllCajasByLocalId } from '../../../../../../../../crud/management_api/workstations';

import {
  getAllPaymentTypes,
  getAllPaymentTypesByLocalId,
} from '../../../../../../../../crud/payments_api/payment_types';

// Función para obtener las opciones de idiomas y formatearlas adecuadamente
export const getLanguagesOptions = async () => {
  try {
    const response = await getAllLanguages();
    if (response && response.data) {
      const languages = response.data.map((lang: any) => ({
        id: lang.language_id,
        label: lang.lang_name,
      }));
      return [{ id: 0, label: 'Ninguno' }, ...languages];
    }
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
  return [{ id: 0, label: 'Ninguno' }];
};

export const getTimezonesOptions = async () => {
  try {
    const response = await getAllTimezones();
    if (response && response.data) {
      const timezones = response.data.map((zone: any) => {
        const name: string = zone.timezone_name || '';
        // Extrae el ÚLTIMO grupo entre paréntesis, p.ej. "Estados Unidos/Canadá"
        const matches = [...name.matchAll(/\(([^)]+)\)/g)];
        const inside = matches.length ? matches[matches.length - 1][1].trim() : null;

        return {
          id: zone.timezone_id,
          label: inside || name, 
        };
      });
      return [{ id: 0, label: 'Ninguno' }, ...timezones];
    }
  } catch (error) {
    console.error('Error fetching timezones:', error);
  }
  return [{ id: 0, label: 'Ninguno' }];
};

export const getMonedasOptions = async () => {
  try {
    const response = await getAllMonedas();
    if (response && response.data) {
      const monedas = response.data.map((moneda: any) => ({
        id: moneda.moneda_id,
        label: `${moneda.currency_name} (${moneda.currency_code})`,
      }));
      return [{ id: 0, label: 'Ninguno' }, ...monedas];
    }
  } catch (error) {
    console.error('Error fetching monedas:', error);
  }
  return [{ id: 0, label: 'Ninguno' }];
};

export const getCajasOptions = async () => {
  try {
    const userContext = localStorage.getItem('user');
    const localId = userContext ? JSON.parse(userContext).local_id : 0;
    const response = await getAllCajasByLocalId(localId);
    if (response && response.data) {
      const cajas = response.data.map((caja: any) => ({
        id: caja.workstation_id,
        label: caja.workstation_name,
      }));
      return [{ id: 0, label: 'Ninguno' }, ...cajas];
    }
  } catch (error) {
    console.error('Error fetching cajas:', error);
  }
  return [{ id: 0, label: 'Ninguna' }];
};

export const getPaymentTypesOptions = async () => {
  try {
    const response = await getAllPaymentTypes();
    if (response && response.data) {
      return response.data.map((type: any) => ({
        id: type.payment_type_id,
        label: type.payment_type_name,
      }));
    }
  } catch (error) {
    console.error('Error fetching payment types:', error);
  }
  return [];
};

export const getPaymentTypesByLocal = async (localId: number) => {
  try {
    const response = await getAllPaymentTypesByLocalId(localId);
    if (response && response.data) {
      return response.data.map((type: any) => type.payment_type_id);
    }
  } catch (error) {
    console.error('Error fetching payment types for local:', error);
  }
  return [];
};

export interface LanguageOption {
  id: number;
  label: string;
}

export interface TimezoneOption {
  id: number;
  label: string;
}

export interface MonedaOption {
  id: number;
  label: string;
}

export interface CajaOption {
  id: number;
  label: string;
}

export interface PaymentTypeOption {
  id: number;
  label: string;
}